import React from 'react';
import { duplicateIcon } from '@chordbaker/design';

interface DuplicateIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
  color?: string;
}

const DuplicateIcon: React.FC<DuplicateIconProps> = ({ size = 16, color = 'currentColor', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill={duplicateIcon.fill}
    viewBox={duplicateIcon.viewBox}
    strokeWidth={duplicateIcon.strokeWidth}
    stroke={color}
    width={size}
    height={size}
    {...props}
  >
    <path
      strokeLinecap={duplicateIcon.strokeLinecap as React.SVGAttributes<SVGPathElement>['strokeLinecap']}
      strokeLinejoin={duplicateIcon.strokeLinejoin as React.SVGAttributes<SVGPathElement>['strokeLinejoin']}
      d={(duplicateIcon.elements[0] as { d: string }).d}
    />
  </svg>
);

export default DuplicateIcon;
